"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const bgRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (bgRef.current) {
        const scrollY = window.scrollY;
        bgRef.current.style.transform = `translateY(${scrollY * 0.5}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={ref} className="relative flex items-center justify-center min-h-screen overflow-hidden">
      <div ref={bgRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/image_aa44553a.png)] will-change-transform" style={{
      transform: "translateY(0px)"
    }} />
      <div className="absolute inset-0 bg-gradient-to-b from-dark-background/70 via-dark-background/60 to-dark-background/80" />

      <div className={`relative z-10 max-w-screen-xl mx-auto px-6 text-center transition-all duration-slow ease-smooth ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="text-5xl md:text-7xl font-display text-white mb-6 leading-tight">
          Sydney Wedding Photography and Videography Services
        </h1>

        <p className="text-lg md:text-xl text-white mb-10 max-w-2xl mx-auto leading-relaxed">
          Your perfect day awaits. Capturing timeless moments of love, joy and celebration
        </p>

        <Link to="#contact">
          <Button size="lg" className="bg-[#B86A5A] text-white hover:bg-[#A55A4A] hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] shadow-medium px-8 py-6 text-base font-semibold">
            Book Your Date
          </Button>
        </Link>
      </div>
    </section>;
}